import React from 'react';

const componentClass = 'nuWave';

const NuWave = () => {
  return <div className={componentClass}>
    <div className="wave0"/>
    <div className="wave1"/>
    <div className="wave2"/>
    <div className="wave3"/>
  </div>
};

export default NuWave;
